import React from "react";
import isEqual from "lodash/isEqual";
import { client } from "../../../utils/keen";
import Chart from "./chart.jsx";

import UserStore from "../../../stores/UserStore";

class KeenChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      data: null,
      lastQuery: null,
      lastOptions: null
    };
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    const { query, options, forceGlobal, processData } = newProps;

    if (!forceGlobal) {
      options.filters = options.filters || [];
      options.filters.push({
        operator: "eq",
        property_name: "tenant.owner",
        property_value: UserStore.getUserId()
      });
    }

    // Don't run same query multiple times
    if (
      query === this.state.lastQuery &&
      isEqual(options, this.state.lastOptions)
    ) {
      return;
    }

    this.setState({ lastQuery: query, lastOptions: options });

    client
      .query(query, options)
      .then(data => {
        if (processData) {
          data = processData(data);
        }

        this.setState({ data });
      })
      .catch(err => {
        this.setState({ message: err.message });
      });
  }

  render() {
    const {
        query,
        options,
        forceGlobal,
        processData,
        children,
        ...rest
      } = this.props,
      { message, data } = this.state;

    if (children) {
      return this.props.children({ message, data });
    }

    return <Chart data={data} message={message} {...rest} />;
  }
}

export default KeenChart;



// WEBPACK FOOTER //
// ./src/app/components/partials/charts/keen-chart.jsx